import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Tracks pending HTTP request count for the loading spinner.
 * Replaces HttpWanaka.pending$ from the old codebase.
 */
@Injectable({ providedIn: 'root' })
export class PendingRequestsService {
  private _pendingRequests = 0;
  public pending$ = new BehaviorSubject<number>(0);

  increment(): void {
    this.pending$.next(++this._pendingRequests);
  }

  decrement(): void {
    this.pending$.next(--this._pendingRequests);
  }
}
